const register = {
  loginCredentials: "Credenciales de acceso", // translated
  companyInformation: "Información de la empresa", // translated
  contactDetails: "Detalles de contacto", // translated
  businessName: "Nombre del Negocio", // translated
  businessAddress: "Dirección de Negocios", // translated
  registrationCode: "Código de registro", // translated
  businessRegistrationNumber: "Número de registro mercantil", // translated
  websiteUrl: "URL del sitio web", // translated
  mobilePhone: "Teléfono móvil", // translated
  regionStateProvince: "Región/Estado/Provincia", // translated
  legalTitle: "Titulo legal", // translated
  city: "Ciudad", // translated
  postalCode: "Código Postal", // translated
  registrationSuccess: "Registración exitosa.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Espere unos momentos y será redirigido a la página de inicio.", // translated
  usernameEmail: "Usuario (correo electrónico)", // translated
  password: "Contraseña", // translated
  verifyPassword: "Verificar contraseña", // translated
  documents: "Documentos", // translated
  termsAndConditionsSection: "Términos y condiciones", // translated
  certificateOfIncorporation: "Certificado de constitución", // translated
  acceptTermsAndConditions: "Aceptar términos y condiciones", // translated
  country: "País", // translated
  brandName: "Nombre de la marca", // translated
  register: "Registrarse", // translated
  isRequired: "Se requiere", // translated
  passwordMin8Chars: "Debe tener al menos 8 caracteres", // translated
  passwordRequiresDigit: "Debe contener al menos 1 dígito", // translated
  passwordRequiresLowercase: "Debe contener al menos 1 letra minúscula", // translated
  passwordRequiresUppercase: "Debe contener al menos 1 letra mayúscula", // translated
  passwordRequiresSpecialChar: 'Debe contener al menos 1 carácter especial (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "Subir archivo", // translated
  filename: "Nombre del archivo:", // translated
  fileType: "Tipo:", // translated
  fileSize: "Tamaño:", // translated
  maxFileSize10Mb: "Máx.: 10 MB", // translated
  supportedFileTypes: "Tipos de archivo compatibles:", // translated
  showPassword: "Mostrar contraseña", // translated
  hidePassword: "Ocultar contraseña", // translated
  notAvailable: "N/D", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "p. ej. +34612345678", // translated
  websiteUrlPlaceholder: "http://www.ejemplo.com", // translated
  loading: "Cargando...", // translated
  uploadingDocument: "Subiendo documento...", // translated
  percentUploaded: "{{percent}}% subido", // translated
  registrationSuccessful: "Registro exitoso.", // translated
  failedToUploadDocument: "Error al subir el documento.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}} debe tener más de {{min}} caracteres", // translated
  fieldMustBeValidEmail: "{{field}} debe ser un correo válido", // translated
  fieldPasswordMinLength: "{{field}} debe tener al menos 8 caracteres", // translated
  fieldPasswordRequiresDigit: "{{field}} debe contener al menos 1 dígito", // translated
  fieldPasswordRequiresLowercase: "{{field}} debe contener al menos 1 letra minúscula", // translated
  fieldPasswordRequiresUppercase: "{{field}} debe contener al menos 1 letra mayúscula", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} debe contener al menos 1 carácter especial (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} no coincide con {{otherField}}", // translated
  fieldBetweenLength: "{{field}} debe tener entre {{min}} y {{max}} caracteres", // translated
  postalCodeBetweenLength: "El código {{field}} debe tener entre {{min}} y {{max}} caracteres", // translated
  invalidUrlFormat: "Formato de URL no válido", // translated
  invalidEmailFormat: "Formato de correo no válido", // translated
  emailMustMatchUsername: "el correo debe ser el mismo que el usuario (correo)", // translated
  mobilePhoneIsRequired: "El teléfono móvil es obligatorio", // translated
  certificateFileTooLarge: "El certificado de constitución es demasiado grande", // translated
  termsMustBeAccepted: "Debe aceptar los términos y condiciones", // translated
};


export default register;
